import { CloseIcon, SearchIcon } from "../../Assets/assets";

export default function SearchBox(props) {
  return (
    <div
      style={{
        borderBottom: "1px solid var(--tertiaryColor6)"
      }}
      className="display-flex flex-justify-content-center flex-align-items-center margin-right-large margin-left-large margin-top-default margin-bottom-large"
    >
      <input
        style={{
          width: "100%"
        }}
        className={`background-color-primary font-color-tertiaryColor inherit-parent-height border-none font-size-large padding-top-default padding-top-default padding-bottom-default padding-right-default inherit-parent-width`}
        value={props.searchKey}
        autoFocus={true}
        onChange={(event) => {
          props.setSearchKey(event.target.value);
        }}
        placeholder={props.placeholder || "Search"}
        title="Search bar"
        data-cy="search-input-field"
      />
      <button
        className="padding-right-default background-color-primary"
        type={"button"}
        data-cy={
          props.searchKey?.length > 0 ? "search-clear-button" : "search-button"
        }
        onClick={() => {
          if (props.searchKey?.length > 0) {
            props.setSearchKey("");
          }
        }}
      >
        {props.searchKey?.length < 1 ? (
          <SearchIcon color="var(--tertiaryColor6)" width={16} height={16} />
        ) : (
          <CloseIcon color="var(--tertiaryColor6)" width={16} height={16} />
        )}
      </button>
    </div>
  );
}
